// extracted by mini-css-extract-plugin
module.exports = {"recentForm":"style_recentForm__TOjt0","opponent":"style_opponent__vKNxp","format":"style_format__onv9T","viewFull":"style_viewFull__hLAkK","item":"style_item___7_RP"};